/*
  TIPA – akční režim stránky kategorie (1. 10. 2026)
  ---------------------------------------------------
  Rozcestník na stránce Výprodej & Akce (sekce k1-rozcestnik, „Akční režim“) vede do
  hlavní kategorie s filtrem Boostu ?pf_t_tag=action%3Atrue&pf_t_tag=sale%3Atrue (Boost
  hodnoty spojí přes NEBO) &pf_m_%3A%3Acustom%3A%3Ainventory_status=in%20stock. To odpovídá
  pravidlům kolekce Výprodej & Akce: štítek sale:true NEBO action:true A skladové zásoby > 0
  (ověřeno v administraci 1. 10. 2026; součet přes K1 5 362 vs. kolekce 5 360).

  Boost podle filtru ukáže jen akční zboží, ale dlaždice podkategorií (.navigation-subcategory,
  na stránce kolekce jsou dvě sekce) vedou bez filtru – zákazník by po kliknutí z akcí vypadl.

  Tento skript v akčním režimu:
    1. připojí akční štítky z adresy k odkazům na podkategorie, takže rozpad
       Fotovoltaika – akce → Bateriové systémy – akce funguje do libovolné hloubky,
    2. místo počtu celé kategorie ukáže u podkategorie počet akčních produktů (Boost API)
       a podkategorie bez akcí schová; počet u nadpisu kategorie skryje,
    3. volitelně (data-stitek na <script>) doplní za nadpis kategorie štítek, např. „Akce“.
  Štítek se ukazuje i bez filtru na samotných akčních kolekcích – výchozí vyprodej-akce
  a vyprodej-akce-b2b (podle adresy i podle ID, protože mutace jako tipa.pl mají adresy
  přeložené: sprzedaz-i-promocje). Jiný seznam adres nebo ID jde zadat atributem
  data-stitek-kolekce="a,b".

  Na stránce s rozcestníkem (sekce k1-rozcestnik v akčním režimu) navíc schová dlaždice
  hlavních kategorií, ve kterých podle filtru v jejich odkazu není žádný produkt
  (např. B2B akce v Auto a moto).

  Mimo akční režim nedělá nic. Když zákazník filtr v Boostu zruší (Boost mění adresu
  přes history.pushState bez načtení stránky), stránka se vrátí do běžného stavu.
*/
(function () {
  'use strict';

  var KLIC = 'pf_t_tag';
  var AKCNI = ['action:true', 'sale:true', 'actionB2B:true']; // actionB2B = kolekce Výprodej & Akce B2B
  // Další filtry, které se v akčním režimu přenášejí beze změny (dostupnost skladem).
  var PRENEST = ['pf_m_::custom::inventory_status'];
  var ODKAZY = '.navigation-subcategory a[href*="/collections/"]';
  var BOOST = 'https://services.mybcapps.com/bc-sf-filter/filter';
  var skript = document.currentScript;
  var stitek = skript && skript.getAttribute('data-stitek');
  var stitekKolekce = ((skript && skript.getAttribute('data-stitek-kolekce')) || 'vyprodej-akce,vyprodej-akce-b2b,674605171026,699195654482')
    .split(',').map(function (x) { return x.trim(); }).filter(Boolean);

  function jeAkcniKolekce() {
    var m = location.pathname.match(/\/collections\/([^\/]+)\/?$/);
    if (m && stitekKolekce.indexOf(decodeURIComponent(m[1])) > -1) return true;
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page;
    return !!meta && meta.resourceType === 'collection' && stitekKolekce.indexOf(String(meta.resourceId)) > -1;
  }
  var shop = (window.Shopify && window.Shopify.shop) || '';
  var pocty = {}; // handle → Promise<počet akčních produktů | null>

  function akcniTagy() {
    return new URLSearchParams(location.search).getAll(KLIC).filter(function (t) {
      return AKCNI.indexOf(t) > -1;
    });
  }

  function dalsiFiltry() {
    var q = new URLSearchParams(location.search), out = [];
    PRENEST.forEach(function (k) { q.getAll(k).forEach(function (v) { out.push([k, v]); }); });
    return out;
  }

  function puvodni(a) {
    if (!a.hasAttribute('data-tipa-puvodni')) {
      a.setAttribute('data-tipa-puvodni', a.getAttribute('href'));
    }
    return new URL(a.getAttribute('data-tipa-puvodni'), location.origin);
  }

  function nactiPocet(cesta, tagy, dalsi) {
    var klic = cesta + '|' + tagy.join(',') + '|' + dalsi.join(',');
    if (pocty[klic]) return pocty[klic];
    try {
      var ulozeno = sessionStorage.getItem('tipa-akce:' + klic);
      if (ulozeno !== null) return (pocty[klic] = Promise.resolve(+ulozeno));
    } catch (e) { /* úložiště nemusí být dostupné */ }
    pocty[klic] = fetch(cesta + '.json', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (d) {
        var q = new URLSearchParams({ shop: shop, limit: '1', collection_scope: d.collection.id });
        tagy.forEach(function (t) { q.append(KLIC + '[]', t); });
        dalsi.forEach(function (kv) { q.append(kv[0] + '[]', kv[1]); });
        return fetch(BOOST + '?' + q.toString());
      })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (d) {
        var n = typeof d.total_product === 'number' ? d.total_product : null;
        try { if (n !== null) sessionStorage.setItem('tipa-akce:' + klic, String(n)); } catch (e) { /* nic */ }
        return n;
      })
      .catch(function () { return null; }); // bez počtu zůstane dlaždice vidět
    return pocty[klic];
  }

  function ukazPocet(a, n) {
    var li = a.closest('li') || a;
    var el = a.querySelector('.tipa-akce-pocet');
    if (n === null) return;
    li.classList.toggle('tipa-akce-prazdna', n === 0);
    if (!el) {
      var nazev = a.querySelector('.navigation-subcategory__title') || a;
      el = document.createElement('span');
      el.className = 'product-count tipa-akce-pocet';
      nazev.appendChild(el);
    }
    el.textContent = '(' + n + ')';
  }

  function rozcestnik() {
    document.querySelectorAll('.k1r a.k1r__tile[href*="' + KLIC + '="]').forEach(function (a) {
      var u = new URL(a.getAttribute('href'), location.origin);
      var tagy = u.searchParams.getAll(KLIC).filter(function (t) { return AKCNI.indexOf(t) > -1; });
      if (!tagy.length || !shop) return;
      var dalsi = [];
      PRENEST.forEach(function (k) { u.searchParams.getAll(k).forEach(function (v) { dalsi.push([k, v]); }); });
      nactiPocet(u.pathname, tagy, dalsi).then(function (n) {
        if (n === 0) (a.closest('li') || a).classList.add('tipa-akce-k1-prazdna');
      });
    });
  }

  function uprav() {
    var tagy = akcniTagy();
    var rezim = tagy.length > 0;
    var dalsi = rezim ? dalsiFiltry() : [];
    var podpis = tagy.join(',') + '|' + dalsi.join(',');
    document.documentElement.classList.toggle('tipa-akce-rezim', rezim);

    document.querySelectorAll(ODKAZY).forEach(function (a) {
      if (!rezim && !a.hasAttribute('data-tipa-puvodni')) return;
      var u = puvodni(a);
      var cesta = u.pathname;
      tagy.forEach(function (t) { u.searchParams.append(KLIC, t); });
      dalsi.forEach(function (kv) { u.searchParams.append(kv[0], kv[1]); });
      a.setAttribute('href', u.pathname + u.search + u.hash);
      if (rezim && shop) {
        nactiPocet(cesta, tagy, dalsi).then(function (n) {
          var t = akcniTagy();
          if (t.join(',') + '|' + (t.length ? dalsiFiltry() : []).join(',') === podpis) ukazPocet(a, n);
        });
      }
    });

    var h = document.querySelector('main h1');
    var st = h && h.querySelector('.tipa-akce-stitek');
    var chciStitek = !!stitek && (rezim || jeAkcniKolekce());
    if (chciStitek && h && !st) {
      st = document.createElement('span');
      st.className = 'tipa-akce-stitek';
      st.textContent = stitek;
      h.append(' ', st); // mezera kvůli čtečkám („Fotovoltaika Akce“, ne „FotovoltaikaAkce“)
    } else if (!chciStitek && st) {
      if (st.previousSibling && st.previousSibling.nodeType === 3 && st.previousSibling.nodeValue === ' ') {
        st.previousSibling.remove();
      }
      st.remove();
    }
  }

  var css = document.createElement('style');
  css.textContent =
    '.tipa-akce-rezim .navigation-subcategory .product-count:not(.tipa-akce-pocet),' +
    '.tipa-akce-rezim .collection-banner__count,' +
    '.tipa-akce-rezim .tipa-akce-prazdna,.tipa-akce-k1-prazdna{display:none!important}' +
    'html:not(.tipa-akce-rezim) .tipa-akce-pocet{display:none!important}' +
    '.tipa-akce-stitek{display:inline-block;margin-left:.1em;padding:.1em .45em;border-radius:4px;' +
    'background:#e30613;color:#fff;font-size:.45em;font-weight:700;line-height:1.4;vertical-align:middle;' +
    'text-transform:uppercase;letter-spacing:.03em}';
  document.head.appendChild(css);

  // Boost mění adresu bez načtení stránky (zrušení filtru, stránkování, řazení).
  ['pushState', 'replaceState'].forEach(function (m) {
    var orig = history[m];
    history[m] = function () {
      var r = orig.apply(this, arguments);
      setTimeout(uprav, 0);
      return r;
    };
  });
  window.addEventListener('popstate', uprav);
  // Pojistka pro případ, že by adresu měnil někdo mimo history API.
  ['pointerdown', 'focusin'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (e.target.closest && e.target.closest(ODKAZY)) uprav();
    }, true);
  });

  function start() { uprav(); rozcestnik(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
